import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PatientStateProvider } from '../../data/patient/domain/patient_state_provider';
import { CollapsiblePatientNoteModule } from '../patient/components/collapsible-patient-note/collapsible-patient-note.module';
import { CollapsiblePatientSurveyModule } from '../patient/components/collapsible-patient-survey/collapsible-patient-survey.module';
import { PatientInfoSidebarModule } from '../patient/components/info-sidebar/patient-info-sidebar.module';
import { MySidebarModule } from './components/my-sidebar/my-sidebar.module';
import { MyTopbarModule } from './components/my-topbar/my-topbar.module';
import { MyComponent } from './my.component';
import { MyDietitianStateProvider } from './my-dietitian-state.provider';
import { MyRoutingModule } from './my-routing.module';
import { MyChartGuard } from './routes/my-chart/my-chart.guard';

@NgModule({
  declarations: [MyComponent],
  imports: [
    CommonModule,
    MyRoutingModule,
    RouterModule,
    CollapsiblePatientNoteModule,
    CollapsiblePatientSurveyModule,
    PatientInfoSidebarModule,
    MySidebarModule,
    MyTopbarModule,
  ],
})
export class MyModule {
  static forRoot(): ModuleWithProviders<MyModule> {
    return {
      ngModule: MyModule,
      providers: [
        MyChartGuard,
        {
          provide: PatientStateProvider,
        },
        {
          provide: MyDietitianStateProvider,
        },
      ],
    };
  }
}
